/**
 * CRM nav panel (PRIVATE fork) — sidebar contextual panel for the CRM tab.
 *
 * Renders the fork-owned `crmModules` as a vertical nav list, mirroring the
 * KnowledgeNavPanel styling. This is the desktop home for the CRM sub-module
 * tabs; on mobile (no sidebar) the CRM page still renders its own top tab bar.
 */

import React from 'react';
import { crmModules } from '../../../pages/crm/nav';

interface CrmNavPanelProps {
  /** First subPath segment, e.g. 'companies'. Empty string = home. */
  activeModule: string;
}

export function CrmNavPanel({ activeModule }: CrmNavPanelProps) {
  const activeKey = activeModule || 'home';

  return (
    <div className="flex flex-col flex-1 min-h-0">
      <nav className="flex-1 overflow-y-auto px-2 pb-2 space-y-0.5" aria-label="CRM navigation">
        {crmModules.map((mod) => {
          const Icon = mod.icon;
          const active = activeKey === mod.key;
          return (
            <a
              key={mod.key}
              href={mod.path}
              aria-current={active ? 'page' : undefined}
              className={`w-full flex items-center gap-2.5 px-3 py-1.5 rounded-md text-xs transition-colors ${
                active
                  ? 'bg-primary-subtle text-primary-fg-strong font-medium'
                  : 'text-fg-secondary hover:text-fg hover:bg-surface-sunken'
              }`}
            >
              <Icon size={14} className={active ? 'text-primary-fg' : 'text-fg-faint'} />
              <span className="flex-1 text-left truncate">{mod.label}</span>
            </a>
          );
        })}
      </nav>
    </div>
  );
}
